module.exports = __webpack_public_path__ + "img/10376@2x.2fe577cc.png";